import keyMirror from 'keymirror'

export default keyMirror({
  READY: null,
  ING: null,
  SUCCEED: null,
  FAILURE: null,
})
